<template>
  <tr>
    <td class="col-3 text-center">
      <img :src="imageUrl" class="img-fluid" :alt="title">
    </td>
    <td class="col-6">
      <strong>{{ title }}</strong>
      <br>
      {{ text }}
    </td>
    <td class="col-3 text-right">
      <label class="btn btn-outline-primary">
        Alterar imagem
        <input type="file" name="image" style="display: none;" accept="image/jpg, image/jpeg, image/png" @change="upload"/>
      </label>
      <br>
      <CButton color="danger" variant="outline" v-if="custom" @click="deleteLogo">
        Excluir imagem
      </CButton>
    </td>
  </tr>
</template>

<script>

export default {
  name: 'LinhaLogotipo',
  props: [
    'title',
    'text',
    'upload',
    'imageUrl',
    'custom',
    'deleteLogo'
  ],
};
</script>